import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { 
  Globe,
  Facebook,
  Instagram,
  ArrowLeft,
  Zap,
  Clock,
  Package,
  ExternalLink,
  Truck
} from 'lucide-react';

const ExpressShippingPage = () => {
  const navigate = useNavigate();
  const [language, setLanguage] = useState('en');

  const sheinProducts = [
    // Clothing
    {
      image: 'https://images.unsplash.com/photo-1764764860028-fd5bee169217?q=80&w=800',
      title: language === 'en' ? 'Floral Jumpsuit' : 'Mono Floral',
      category: language === 'en' ? 'Clothing' : 'Ropa',
      url: 'https://www.shein.com/Women-Jumpsuits-c-2137.html'
    },
    {
      image: 'https://images.unsplash.com/photo-1762343292182-b0cb71a19111?q=80&w=800',
      title: language === 'en' ? 'Casual Two-Piece' : 'Conjunto Casual',
      category: language === 'en' ? 'Clothing' : 'Ropa',
      url: 'https://www.shein.com/Women-Two-Piece-Outfits-c-2057.html'
    },
    {
      image: 'https://images.unsplash.com/photo-1762343291569-680a1efe1fbb?q=80&w=800',
      title: language === 'en' ? 'Summer Outfit' : 'Conjunto de Verano',
      category: language === 'en' ? 'Clothing' : 'Ropa',
      url: 'https://www.shein.com/Women-Two-Piece-Outfits-c-2057.html'
    },
    {
      image: 'https://images.unsplash.com/photo-1766556514013-e0c6edddf26e?q=80&w=800',
      title: language === 'en' ? 'Floral Co-ord Set' : 'Conjunto Floral',
      category: language === 'en' ? 'Clothing' : 'Ropa',
      url: 'https://www.shein.com/Women-Two-Piece-Outfits-c-2057.html'
    },
    {
      image: 'https://images.unsplash.com/photo-1761574028262-6d834741bfd8?q=80&w=800',
      title: language === 'en' ? 'Black Evening Gown' : 'Vestido Negro',
      category: language === 'en' ? 'Dresses' : 'Vestidos',
      url: 'https://www.shein.com/Women-Dresses-c-1727.html'
    },
    {
      image: 'https://images.unsplash.com/photo-1754299257780-71fd1f741cf2?q=80&w=800',
      title: language === 'en' ? 'Pink Floral Dress' : 'Vestido Floral Rosa',
      category: language === 'en' ? 'Dresses' : 'Vestidos',
      url: 'https://www.shein.com/Women-Dresses-c-1727.html'
    },
    {
      image: 'https://images.unsplash.com/photo-1726194158976-0a6d69d81c13?q=80&w=800',
      title: language === 'en' ? 'Red Party Dress' : 'Vestido Rojo de Fiesta',
      category: language === 'en' ? 'Dresses' : 'Vestidos',
      url: 'https://www.shein.com/Women-Dresses-c-1727.html'
    },
    {
      image: 'https://images.unsplash.com/photo-1650591038434-649e2ce3915c?q=80&w=800',
      title: language === 'en' ? 'Casual Streetwear' : 'Ropa Casual',
      category: language === 'en' ? 'Clothing' : 'Ropa',
      url: 'https://www.shein.com/Women-Clothing-c-2030.html'
    },
    // Jewelry
    {
      image: 'https://images.unsplash.com/photo-1758995115867-4ef47c98824e?q=80&w=800',
      title: language === 'en' ? 'Gold Necklace Set' : 'Conjunto de Collar',
      category: language === 'en' ? 'Jewelry' : 'Joyería',
      url: 'https://www.shein.com/Women-Jewelry-c-1755.html'
    },
    {
      image: 'https://images.unsplash.com/photo-1614606140905-6a5e931e5c39?q=80&w=800',
      title: language === 'en' ? 'Gold Statement Necklace' : 'Collar Dorado',
      category: language === 'en' ? 'Jewelry' : 'Joyería',
      url: 'https://www.shein.com/Women-Jewelry-c-1755.html'
    },
    {
      image: 'https://images.unsplash.com/photo-1551734465-bf8cc92570f5?q=80&w=800',
      title: language === 'en' ? 'Layered Necklaces' : 'Collares en Capas',
      category: language === 'en' ? 'Jewelry' : 'Joyería',
      url: 'https://www.shein.com/Women-Jewelry-c-1755.html'
    },
    {
      image: 'https://images.unsplash.com/photo-1755537131397-66ef374269de?q=80&w=800',
      title: language === 'en' ? 'Pearl Clutch' : 'Bolso de Perlas',
      category: language === 'en' ? 'Accessories' : 'Accesorios',
      url: 'https://www.shein.com/Women-Bags-c-1764.html'
    },
    // Shoes
    {
      image: 'https://images.unsplash.com/photo-1621996659490-3275b4d0d951?q=80&w=800',
      title: language === 'en' ? 'Brown Peep Toe Heels' : 'Tacones Marrones',
      category: language === 'en' ? 'Shoes' : 'Zapatos',
      url: 'https://www.shein.com/Women-Heels-c-2095.html'
    },
    {
      image: 'https://images.unsplash.com/photo-1534653299134-96a171b61581?q=80&w=800',
      title: language === 'en' ? 'Yellow Strap Sandals' : 'Sandalias Amarillas',
      category: language === 'en' ? 'Shoes' : 'Zapatos',
      url: 'https://www.shein.com/Women-Heels-c-2095.html'
    },
    {
      image: 'https://images.unsplash.com/photo-1760473004054-eb0fd50ea9ae?q=80&w=800',
      title: language === 'en' ? 'Red Bow Heels' : 'Tacones Rojos',
      category: language === 'en' ? 'Shoes' : 'Zapatos',
      url: 'https://www.shein.com/Women-Heels-c-2095.html'
    },
    {
      image: 'https://images.unsplash.com/photo-1576503452943-f6a35d851fc0?q=80&w=800',
      title: language === 'en' ? 'Wedge Sandals' : 'Sandalias de Cuña',
      category: language === 'en' ? 'Shoes' : 'Zapatos',
      url: 'https://www.shein.com/Women-Sandals-c-2094.html'
    },
    {
      image: 'https://images.unsplash.com/photo-1566499003412-4736d6099504?q=80&w=800',
      title: language === 'en' ? 'Black Sandals' : 'Sandalias Negras',
      category: language === 'en' ? 'Shoes' : 'Zapatos',
      url: 'https://www.shein.com/Women-Sandals-c-2094.html'
    },
    {
      image: 'https://images.unsplash.com/photo-1764179690182-79465d8d4161?q=80&w=800',
      title: language === 'en' ? 'Designer Handbag' : 'Bolso de Diseño',
      category: language === 'en' ? 'Accessories' : 'Accesorios',
      url: 'https://www.shein.com/Women-Bags-c-1764.html'
    }
  ];

  const content = language === 'en' ? {
    title: "SHEIN Express Shipping",
    subtitle: "Get Your Fashion Faster!",
    regularTitle: "Regular Shipping",
    regularTime: "Up to 4 weeks",
    regularDesc: "Standard delivery for all products",
    expressTitle: "Express Shipping ⚡",
    expressTime: "7-10 Days",
    expressDesc: "Fast-track delivery for SHEIN products only",
    howItWorks: "How Express Shipping Works",
    step1: "Select Your Items",
    step1desc: "Browse and choose from trending SHEIN products below",
    step2: "Request Express Quote",
    step2desc: "Mention 'Express Shipping' in your quote request",
    step3: "Fast Delivery",
    step3desc: "Receive your SHEIN products in just 7-10 days!",
    products: "Trending SHEIN Products",
    productsDesc: "All items available for express shipping",
    available: "Available for Express",
    cta: "Request Express Quote"
  } : {
    title: "Envío Exprés de SHEIN",
    subtitle: "¡Recibe tu Moda Más Rápido!",
    regularTitle: "Envío Regular",
    regularTime: "Hasta 4 semanas",
    regularDesc: "Entrega estándar para todos los productos",
    expressTitle: "Envío Exprés ⚡",
    expressTime: "7-10 Días",
    expressDesc: "Entrega rápida solo para productos SHEIN",
    howItWorks: "Cómo Funciona el Envío Exprés",
    step1: "Selecciona tus Artículos",
    step1desc: "Navega y elige entre los productos SHEIN tendencia",
    step2: "Solicita Cotización Exprés",
    step2desc: "Menciona 'Envío Exprés' en tu solicitud",
    step3: "Entrega Rápida",
    step3desc: "¡Recibe tus productos SHEIN en solo 7-10 días!",
    products: "Productos SHEIN en Tendencia",
    productsDesc: "Todos los artículos disponibles para envío exprés",
    available: "Disponible para Exprés",
    cta: "Solicitar Cotización Exprés"
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#f7f5f2] to-white">
      {/* Header */}
      <header className="fixed top-0 w-full bg-white/90 backdrop-blur-md shadow-sm z-50">
        <div className="container mx-auto px-4 py-3 flex justify-between items-center">
          <div className="flex items-center gap-4">
            <Button
              variant="ghost"
              onClick={() => navigate('/')}
              className="flex items-center gap-2 text-[#8b1538] hover:text-[#6b0f2a]"
            >
              <ArrowLeft className="w-5 h-5" />
              <span className="hidden sm:inline">
                {language === 'en' ? 'Back to Home' : 'Volver'}
              </span>
            </Button>
            
            <img 
              src="https://customer-assets.emergentagent.com/job_57e2dd96-4e50-451b-8abf-042890e7a51b/artifacts/m648krxt_Athena%27s%20Logo.png"
              alt="Athena's"
              className="h-12 w-auto object-contain cursor-pointer"
              onClick={() => navigate('/')}
            />
          </div>
          
          <div className="flex items-center gap-4">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setLanguage(language === 'en' ? 'es' : 'en')}
              className="flex items-center gap-2"
            >
              <Globe className="w-4 h-4" />
              {language === 'en' ? 'ES' : 'EN'}
            </Button>
            <a 
              href="https://www.facebook.com/profile.php?id=61584846392424" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#8b1538] hover:text-[#6b0f2a] transition-colors"
            >
              <Facebook className="w-6 h-6" />
            </a>
            <a 
              href="https://www.instagram.com/athenasonlineshoppingservices/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#8b1538] hover:text-[#6b0f2a] transition-colors"
            >
              <Instagram className="w-6 h-6" />
            </a>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="pt-32 pb-12 px-4">
        <div className="container mx-auto text-center">
          <div className="inline-block mb-4 px-6 py-2 bg-gradient-to-r from-[#8b1538] to-[#fad24b] rounded-full">
            <span className="text-white font-bold flex items-center gap-2 justify-center">
              <Zap className="w-5 h-5" />
              {content.expressTitle}
            </span>
          </div>
          
          <h1 className="text-4xl md:text-6xl font-bold text-[#1e1919] mb-4">
            {content.title}
          </h1>
          <p className="text-xl text-[#736c64] mb-8">
            {content.subtitle}
          </p>
        </div>
      </section>

      {/* Shipping Options */}
      <section className="py-12 px-4">
        <div className="container mx-auto max-w-5xl">
          <div className="grid md:grid-cols-2 gap-8">
            <Card className="border-2 border-[#736c64]/30">
              <CardContent className="p-8 text-center">
                <Package className="w-16 h-16 text-[#736c64] mx-auto mb-4" />
                <h3 className="text-2xl font-bold text-[#1e1919] mb-2">{content.regularTitle}</h3>
                <p className="text-3xl font-bold text-[#8b1538] mb-4">{content.regularTime}</p>
                <p className="text-[#736c64]">{content.regularDesc}</p>
              </CardContent>
            </Card>

            <Card className="border-2 border-[#8b1538] bg-gradient-to-br from-[#8b1538]/5 to-[#fad24b]/10 relative overflow-hidden">
              <div className="absolute top-4 right-4 bg-[#fad24b] text-[#1e1919] px-3 py-1 rounded-full text-xs font-bold">
                ⚡ FAST
              </div>
              <CardContent className="p-8 text-center">
                <Zap className="w-16 h-16 text-[#8b1538] mx-auto mb-4" />
                <h3 className="text-2xl font-bold text-[#1e1919] mb-2">{content.expressTitle}</h3>
                <p className="text-4xl font-bold text-[#8b1538] mb-4">{content.expressTime}</p>
                <p className="text-[#1e1919] font-semibold">{content.expressDesc}</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-12 px-4 bg-white">
        <div className="container mx-auto max-w-5xl">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-[#1e1919] mb-12">
            {content.howItWorks}
          </h2>
          
          <div className="grid md:grid-cols-3 gap-8">
            <Card className="border-2 border-[#fad24b]/30">
              <CardContent className="p-6 text-center">
                <div className="w-16 h-16 bg-[#fad24b]/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-3xl font-bold text-[#8b1538]">1</span>
                </div>
                <h3 className="text-xl font-bold text-[#1e1919] mb-2">{content.step1}</h3>
                <p className="text-[#736c64]">{content.step1desc}</p>
              </CardContent>
            </Card>

            <Card className="border-2 border-[#ff8c19]/30">
              <CardContent className="p-6 text-center">
                <div className="w-16 h-16 bg-[#ff8c19]/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-3xl font-bold text-[#8b1538]">2</span>
                </div>
                <h3 className="text-xl font-bold text-[#1e1919] mb-2">{content.step2}</h3>
                <p className="text-[#736c64]">{content.step2desc}</p>
              </CardContent>
            </Card>

            <Card className="border-2 border-[#3dd3ee]/30">
              <CardContent className="p-6 text-center">
                <div className="w-16 h-16 bg-[#3dd3ee]/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Truck className="w-8 h-8 text-[#8b1538]" />
                </div>
                <h3 className="text-xl font-bold text-[#1e1919] mb-2">{content.step3}</h3>
                <p className="text-[#736c64]">{content.step3desc}</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Products */}
      <section className="py-16 px-4">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-[#1e1919] mb-4">
              {content.products}
            </h2>
            <p className="text-lg text-[#736c64]">{content.productsDesc}</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-6 max-w-7xl mx-auto">
            {sheinProducts.map((product, index) => (
              <Card 
                key={index}
                className="group overflow-hidden border-2 border-transparent hover:border-[#8b1538]/30 transition-all transform hover:scale-105 hover:shadow-xl"
              >
                <div className="relative overflow-hidden aspect-square">
                  <img 
                    src={product.image}
                    alt={product.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  <div className="absolute top-2 right-2 bg-[#fad24b] text-[#1e1919] px-2 py-1 rounded text-xs font-bold flex items-center gap-1">
                    <Zap className="w-3 h-3" />
                    {language === 'en' ? 'EXPRESS' : 'EXPRÉS'}
                  </div>
                  <a
                    href={product.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="absolute bottom-2 right-2 bg-white/90 backdrop-blur-sm p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 hover:bg-white"
                  >
                    <ExternalLink className="w-4 h-4 text-[#8b1538]" />
                  </a>
                </div>
                <CardContent className="p-3">
                  <span className="text-xs font-semibold text-[#8b1538] uppercase tracking-wide">
                    SHEIN
                  </span>
                  <h3 className="text-sm font-bold text-[#1e1919] mt-1 line-clamp-1">
                    {product.title}
                  </h3>
                  <p className="text-xs text-[#736c64] mt-1">{product.category}</p>
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="text-center mt-12">
            <Button
              size="lg"
              onClick={() => navigate('/')}
              className="bg-[#8b1538] hover:bg-[#6b0f2a] text-white px-10 py-6 text-lg font-semibold transition-all transform hover:scale-105"
            >
              <Zap className="w-5 h-5 mr-2" />
              {content.cta}
            </Button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1e1919] text-white py-8 px-4">
        <div className="container mx-auto text-center">
          <div className="flex items-center justify-center gap-6 mb-4">
            <a
              href="https://www.facebook.com/profile.php?id=61584846392424"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook-link"
              className="text-[#fad24b] hover:text-white transition-colors"
            >
              <Facebook className="w-6 h-6" />
            </a>
            <a
              href="https://www.instagram.com/athenasonlineshoppingservices/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              className="text-[#fad24b] hover:text-white transition-colors"
            >
              <Instagram className="w-6 h-6" />
            </a>
          </div>
          <p className="text-[#bbb5ae] text-sm mb-3">
            Business Hours: 10 AM - 9 PM (7 Days)
          </p>
          <div className="mb-4 text-sm space-y-1">
            <p className="text-[#bbb5ae]">
              Phone: <a href="tel:+5016735717" data-testid="footer-phone-link" className="text-[#fad24b] hover:text-white transition-colors">6735717</a>
            </p>
            <p className="text-[#bbb5ae]">
              WhatsApp: <a href="https://wa.me/5016735717" target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="text-[#fad24b] hover:text-white transition-colors">Chat with us</a>
            </p>
            <p className="text-[#bbb5ae]">
              Email: <a href="mailto:athenasonlineshoppingservices@gmail.com" data-testid="footer-email-link" className="text-[#fad24b] hover:text-white transition-colors break-all">athenasonlineshoppingservices@gmail.com</a>
            </p>
            <p className="text-[#bbb5ae]">
              <a href="/privacy" data-testid="footer-privacy-link" className="text-[#fad24b] hover:text-white transition-colors">Privacy Policy</a>
            </p>
          </div>
          <p className="text-[#bbb5ae] text-sm">
            © {new Date().getFullYear()} Athena's Online Shopping Services. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default ExpressShippingPage;
